import React, { useEffect, useState } from "react";
import { updateData } from "../libs/auth.helper";
import { SocketContextProvider } from "./Socket";
import { NotificationAudio } from "../audio";
import notificationSocket from "../sockets/notification.socket";
const MainContext = React.createContext({});
export const MainContextProvider = (props) => {
    const { authenticationData, lang, publicUrl, urls, getToken, RTHandler } = props;
    const [config, setConfig] = useState({
        lang, authenticationData, publicUrl, urls, getToken, RTHandler
    });
    if (authenticationData)
        updateData(authenticationData);
    if (props.urls.notify)
        NotificationAudio.setConfig({
            src: props.urls.notify
        });
    notificationSocket.bind(null, urls.gulpin2);
    useEffect(() => {
        setConfig(old => {
            return Object.assign(Object.assign({}, old), { lang,
                authenticationData });
        });
    }, [lang, authenticationData]);
    return (React.createElement(MainContext.Provider, { value: Object.assign({}, config) },
        React.createElement(SocketContextProvider, null, props.children)));
};
export default MainContext;
